import Random from 'java-random';
import { useState, useEffect } from 'react';

const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

function getCodeOfTheDay() {
  const epochDay = Math.floor(Date.now() / MILLISECONDS_IN_DAY);
  const randomInt = new Random(epochDay).nextInt();
  const codeOfTheDay = `${randomInt}`.substring(2, 6);
  return codeOfTheDay;
}

const useCurrentDay = () => {
  const [day, setDay] = useState<number>(new Date().getUTCDay());

  useEffect(() => {
    const intervalID = setInterval(() => {
      setDay(new Date().getUTCDay());
    }, 1000);
    return () => {
      clearInterval(intervalID);
    };
  }, []);

  return day;
};

export const useDailyCode = () => {
  const [dailyCode, setDailyCode] = useState<string | undefined>(undefined);
  const currentDay = useCurrentDay();

  useEffect(() => {
    try {
      const codeOfTheDay = getCodeOfTheDay();
      setDailyCode(codeOfTheDay);
    } catch (error) {
      setDailyCode(undefined);
    }
  }, [currentDay]);

  return dailyCode;
};
